import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleRight, faBell} from "@fortawesome/free-solid-svg-icons";

import './AlertView.css';
import {ToolTip} from "../../common/tool-tip/ToolTip";
import {loadUserProfile} from "../../../services/AccountService";
import {viewProblem} from "../../../services/ProblemService";
import {retrieveIndicator} from "../../../services/IndicatorService";
import {retrieveVisitWithPeople} from "../../../services/VisitService";

export const AlertView = ({
                                     context,
                                     showToaster,
                                     setSpinnerText,
                                     toolTipsEnabled,
                                     setContext,
                                     navigateTo
                                 }) => {

    const [userProfile, setUserProfile] = useState(null);
    const [userNotificationList, setUserNotificationList] = useState(null);
    const [userAlertList, setUserAlertList] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            await loadProfile();
        }
        fetchData();
    }, []);

    const loadProfile = async () => {
        setSpinnerText("Loading alerts");
        const [data, error] = await loadUserProfile(context.username);
        if (data) {
            if (data.responseStatus === "Success") {
                const userProfileRetrieved = data.userProfileVO;
                if (userProfileRetrieved) {
                    setUserProfile(userProfileRetrieved);
                    const userNotificationListRetrieved = data.userProfileVO.notificationVOS;
                    const userAlertListRetrieved = data.userProfileVO.alertVOS;
                    setUserAlertList(userAlertListRetrieved);
                    setUserNotificationList(userNotificationListRetrieved.reverse());
                }
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const handleAlertGoToClick = async (extRef) => {
        setSpinnerText("Loading screen");
        const selectedAlert = userAlertList.find(AlertVO => AlertVO.problemExternalReference === extRef)
        if (selectedAlert) {
            await handleProblemClick(selectedAlert.problemExternalReference)
        }
        setSpinnerText(null);
    }


    const handleProblemClick = async (externalReference) => {
        setSpinnerText("Retrieving Problem");
        let savedVisit = null;
        let savedIndicator = null;
        const savedProblem = await fetchProblem(externalReference);

        if (savedProblem) {
            savedVisit = await fetchVisit(savedProblem.visitExternalRef);
        }

        if (savedVisit) {
            savedIndicator = await fetchIndicator(savedVisit.indicatorExternalReference);
        }

        if (savedIndicator) {
            setContext((prevState) => ({
                ...prevState,
                viewMode: true,
                editMode: true,
                breadcrumbs: [],
                changeIdeaScreen: null,
                copyOfTopicAreaScreen: null,
                copyOfProblemScreen: null,
                copyOfRootCauseScreen: null,
                copyOfChangeIdeaScreen: null,
                problemScreen: {
                    externalReference: savedProblem.externalReference,
                    title: savedProblem.name,
                    description: savedProblem.description,
                    nextVisitDate: savedVisit.dateOfNextVisit,
                    frequency: {
                        label: savedProblem.reviewFrequency,
                        value: savedProblem.reviewFrequency
                    },
                    baselines: savedProblem.outcomeMeasureBaselines,
                    toImprove: savedProblem.aimStatementVO.toImprove,
                    from: savedProblem.aimStatementVO.from,
                    to: savedProblem.aimStatementVO.to,
                    byDate: savedProblem.aimStatementVO.by,
                },
                problemToBeViewedExternalReference: savedProblem.externalReference,
                rootCauseScreen: null,
                topicAreaScreen: {
                    visitExternalReference: savedProblem.visitExternalRef,
                    indicator: {
                        outcomeMeasure: savedIndicator.outcomeMeasure,
                        numerator: savedIndicator.numerator,
                        denominator: savedIndicator.denominator,
                    },
                    topicArea: {
                        externalReference: savedProblem.topicAreaExternalRef,
                        topicArea: savedProblem.topicAreaName,
                    },
                    grant: {externalReference: savedProblem.grantExternalRef, name: null},
                },
                facilityScreen: {
                    levelOfSupport: {label: savedProblem.levelOfSupport},
                    locationExternalReference: savedProblem.locationExternalRef,
                },
            }));
            navigateTo("problemOne");
        }
        setSpinnerText(null);
    }

    const fetchProblem = async (problemExternalReference) => {
        let savedProblem = null;
        const [data, error] = await viewProblem(context.username, problemExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedProblem = data.problemVOToView;
            } else {
                showToaster(error);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedProblem;
    }

    const fetchIndicator = async (indicatorExternalReference) => {
        let savedIndicator = null;
        const [data, error] = await retrieveIndicator(context.username, indicatorExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedIndicator = data.indicatorVOToView;
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedIndicator;
    }

    const fetchVisit = async (visitExternalReference) => {
        let savedVisit = null;
        const [data, error] = await retrieveVisitWithPeople(context.username, visitExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedVisit = data.visitVOToView;
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        return savedVisit;
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-right-container-n">
                    <div className="alert-container">
                        <div className={"label-div-tooltip-nn"}>
                            <label className={"label"}>Alerts:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"alerts123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Alerts:"}/>}
                        </div>
                        <div className={"text-box-alert"}>
                            {userProfile !== null && userNotificationList !== null ?
                                <ul className={"comment-container-alert"}>
                                    {userAlertList.map((AlertVO, index) => (
                                        <li key={index} className={"comment-message-container-n"}>
                                            <div>
                                                <button className={"acknowledge-alert-button"}>
                                                    <FontAwesomeIcon className="eye-icon" icon={faBell}/>
                                                </button>
                                                {AlertVO.message}
                                                {AlertVO.message.includes("roblem") &&
                                                <button className={"acknowledge-notification-button"}
                                                        onClick={() => handleAlertGoToClick(AlertVO.problemExternalReference)}>
                                                    <FontAwesomeIcon className="eye-icon" icon={faArrowCircleRight}/>
                                                </button>}
                                            </div>
                                        </li>))}
                                </ul> :
                                <p className={"no-comments-message"}>No alerts yet</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
